import template from './delivery_region_routing.edit.html';
import controller from './delivery_region_routing.edit.controller';
import './delivery_region_routing.edit.scss';

let deliveryRegionRoutingEditComponent = {
    restrict: 'E',
    bindings: {
        hasACL: '='
    },
    template,
    controller
}

export default deliveryRegionRoutingEditComponent;


// WEBPACK FOOTER //
// ./client/app/components/delivery_region_routing/edit/delivery_region_routing.edit.component.js